import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';

const DropdownListWrapper = styled.div((props) => {
    const { layout, colours, palette } = ThemeHelper.getTheme(props);

    return `position: relative;
    display: table;
    font-family: inherit;
    border: 1px solid ${colours.grey[200]};
    border-radius: ${layout.borderRadius};

    .icon {
        display: block;
    }

    .icon {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 8px solid #778088;
        margin-top: -4px;
        content: " ";
        position: absolute;
        top: 50%;
        right: 8px;
        pointer-events: none;
        display: block;
    }

    select {
        background: none;
        border-radius: 0.2em;
        border: 1px solid transparent;
        width: 100%;
        margin: 0;
        outline: none;
        padding: 0.55em 0.8em 0.45em;
        padding-right: 30px;
        font-family: inherit;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.3;
        color: ${palette.primary.main};
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;

        &:focus {
            outline: none;
        }
    }

    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        select::-ms-expand {
            display: none;
        }

        select:focus {
            border-color: orange;
        }

        select:focus::-ms-value {
            background: transparent;
            color: yellow;
        }

        select {
            padding-right: 2em;
            background: none;
            border: 1px solid transparent;
        }

        &::after {
            display: block;
        }
    }
`;
});

export default DropdownListWrapper;



// WEBPACK FOOTER //
// ./app/components/dropdown-list/styled.js